(function () {
  'use strict';

  // ─── Mobile nav toggle ─────────────────────────────────────
  var hamburger  = document.getElementById('obw-hamburger');
  var mobileNav  = document.getElementById('obw-mobile-nav');

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      hamburger.setAttribute('aria-expanded', open);
      hamburger.classList.toggle('is-open', open);
    });
    // Close on outside click
    document.addEventListener('click', function (e) {
      if (!hamburger.contains(e.target) && !mobileNav.contains(e.target)) {
        mobileNav.classList.remove('is-open');
        hamburger.classList.remove('is-open');
        hamburger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // ─── Cart drawer / count refresh ───────────────────────────
  // Shopify provides cart.item_count server-side; for AJAX add-to-cart
  // update the badge without a full page reload.
  document.addEventListener('cart:updated', function (e) {
    var badge = document.querySelector('.obw-cart-badge');
    if (badge && e.detail && typeof e.detail.count !== 'undefined') {
      badge.textContent = e.detail.count > 9 ? '9+' : e.detail.count;
      badge.style.display = e.detail.count > 0 ? '' : 'none';
    }
  });

  // ─── Add-to-cart AJAX ──────────────────────────────────────
  document.querySelectorAll('[data-add-to-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-atc-btn]');
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      var data = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: data })
        .then(function (r) { return r.json(); })
        .then(function () {
          return fetch('/cart.js');
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: cart.item_count } }));
          if (btn) { btn.disabled = false; btn.textContent = 'Added ✓'; }
          setTimeout(function () { if (btn) btn.textContent = btn.dataset.label || 'Add to Cart'; }, 2000);
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = 'Error — try again'; }
        });
    });
  });

  // ─── Cart item quantity / remove ──────────────────────────
  document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.dataset.cartRemove;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
      .then(function () { location.reload(); });
    });
  });

})();

// Plan selector
var planRows = document.querySelectorAll('.obw-plan-row');
var variantInput = document.getElementById('obw-variant-id');
planRows.forEach(function(row) {
  row.addEventListener('click', function() {
    planRows.forEach(function(r) { r.classList.remove('is-selected'); });
    row.classList.add('is-selected');
    if (variantInput) variantInput.value = row.dataset.variantId;
  });
});